export const RULES_FOR_OBTAINING_PROFESSIONAL_PERMISSIONS_ROUTE = 'zasady-zdobywania-kwalifikacji-dla-kierowcow-zawodowych';
